type TenantGrants = ReadonlyArray<{
  type: string;
  permissions: ReadonlyArray<{ type: string; method: string; route: string }>;
}>;

type GrantMatch = { type: string; method: string; route: string };

/**
 * One access record must be both a super-tenant and hold the exact grant —
 * mirroring the API's no-bypass platform checks. A super-tenant membership
 * plus the grant on a different org is not enough.
 */
export function hasSuperTenantGrant(tenants: TenantGrants, grant: GrantMatch): boolean {
  return tenants.some(
    (tenant) =>
      tenant.type === "SUPER_TENANT" &&
      tenant.permissions.some(
        (permission) =>
          permission.type === grant.type &&
          permission.method === grant.method &&
          permission.route === grant.route,
      ),
  );
}

/** The system-settings API allows the call only with the admin page on a super-tenant record. */
export function hasSuperTenantAdminPage(tenants: TenantGrants): boolean {
  return hasSuperTenantGrant(tenants, { type: "PAGE", method: "GET", route: "admin" });
}
